<template>
  <div class="news-title">
    <span v-if="title" v-html="highlightedTitle"></span>
    <el-skeleton :rows="0" v-else />
  </div>
</template>

<script setup>
  import { computed } from 'vue'
  import { highlightText } from '@/hooks/useKeywordHighlight.js'

  const props = defineProps({
    title: {
      type: String,
      default: null
    },
    keyword: {
      type: String,
      default: ''
    }
  })

  const highlightedTitle = computed(() => highlightText(props.title, props.keyword))
</script>

<style lang="scss">
  // 在pc端展示
  .news-title .search-keyword {
    background: #fff0a6;
    color: #9d5a00;
    border-radius: 2px;
    padding: 0 2px;
  }

  @media screen and (min-width: $media) {
    .news-title {
      display: flex;
      justify-content: center;
      span {
        width: 100%;
        display: inline-block;
        font-size: .2813rem;
        font-weight: bold;
        color: $hover-color;
        border-bottom: .0156rem solid $hover-color;
        text-align: center;
        padding-top: .5rem;
        padding-bottom: .25rem;
        margin-bottom: .4375rem;
      }

      .el-skeleton {
        display: flex;
        justify-content: center;
        width: 100%;
        display: inline-block;
        font-size: .2813rem;
        font-weight: bold;
        color: $hover-color;
        border-bottom: .0156rem solid $hover-color;
        text-align: center;
        padding-top: .5rem;
        padding-bottom: .25rem;
        margin-bottom: .4375rem;

        .el-skeleton__item {
          height: .3906rem !important;
        }
      }
    }
  }
  // 在移动端展示
  @media screen and (max-width: $media) {
    .news-title {
      display: flex;
      justify-content: center;
      span {
        width: 100%;
        display: inline-block;
        font-size: 4.2667vw;
        font-weight: bold;
        color: $hover-color;
        border-bottom: 0.4vw solid #b9b9b9;
        text-align: center;
        padding-top: 6.4vw;
        padding-bottom: 4.2667vw;
        margin-bottom: 4.2667vw;
      }

      .el-skeleton {
        display: flex;
        justify-content: center;
        width: 100%;
        display: inline-block;
        font-size: 36px;
        font-weight: bold;
        color: $hover-color;
        border-bottom: 2px solid $hover-color;
        text-align: center;
        padding-top: 64px;
        padding-bottom: 32px;
        margin-bottom: 56px;

        .el-skeleton__item {
          height: 50px !important;
        }
      }
    }
  }
</style>
